import HasID from "./HasID";

export interface Shipment extends HasID {
    shipmentType: string,
    verified: Date,
    verifiedBy: string,
    shipped: Date,
    shippedBy: string,
    voided: boolean,
    avalaraDocumentId: string,
    trackingNumber: string,
    shippingStation: string,
    shippingCost: number,
    serviceType: string,
    trackingUrl: string,
    shipEngineShipmentId: string,
    delivered: boolean,
    anticipatedDeliveryDate: Date,
    actualDeliveryDate: Date,
    deliveryConfirmationDate: Date,
    deliveryConfirmationIP: string,
    deliveryConfirmationSignature: string,

    address1: string,
    address2: string,
    city: string,
    state: string
    zip: string,
    returnDate: Date,
    returnReason: string,
    deliveryProofImageId?: number
}

export class Shipment {

    constructor(obj?: Shipment) {
        if (obj) {
            Object.assign(this, obj);
            if (obj.returnDate) this.returnDate = new Date(obj.returnDate);
        }
    }

    get fullAddress(): string {
        let fullAddress = (this.address1 || '')
            + (this.address2 ? ', ' + this.address2 : '')
            + (this.city ? ', ' + this.city : '');

        const addrStateZip = (this.state || '') + ' ' + (this.zip || '');
        fullAddress += addrStateZip.replace(' ', '') ? (', ' + addrStateZip) : '';

        return fullAddress.trim();
    }
}
